module.exports = __webpack_public_path__ + "assets/img/5.19ad8bd9.png";